import React, { useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import { noop } from '../../../common/propTypes';
import LoadingComponent from '../../../common/LoadingComponent';

function NotificationList({
    notifications,
    selectedNotification,
    loading,
    onClick,
    moreDataCallback,
    hasMoreData,
}) {
    const observer = useRef();
    const lastNotificationRef = useCallback(
        (node) => {
            if (loading) return; // if the current state of notifications is loading we don't need to execute the callback
            if (observer.current) observer.current.disconnect(); // remove the old observer
            observer.current = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting && hasMoreData) {
                    moreDataCallback(); // if the last node is visible, callback is invoked to fetch more notificatons
                }
            });
            if (node) observer.current.observe(node); // last node is used as the new observer
        },
        [loading, hasMoreData],
    );
    const loader = (
        <div className="">
            <LoadingComponent isLoading={loading} />
        </div>
    );

    return (
        <div className="notification-list custom-scroll">
            {notifications.length
                ? notifications.map((note, index) => (
                      <div
                          ref={
                              notifications.length == index + 1
                                  ? lastNotificationRef
                                  : null
                          }
                          key={note.id}
                          className={`notification-item ${
                              selectedNotification.id == note.id ? 'active' : ''
                          }`}
                          onClick={() => onClick(note)}
                      >
                          <label className="title">{note.title}</label>
                          <p className="desc">{note.message}</p>
                          <label className="time">{note.date}</label>
                      </div>
                  ))
                : 'No Notifications'}
            {loader}
        </div>
    );
}

NotificationList.propTypes = {
    notifications: PropTypes.array,
    selectedNotification: PropTypes.object,
    onClick: PropTypes.func,
    loading: PropTypes.bool,
    moreDataCallback: PropTypes.func,
    hasMoreData: PropTypes.bool,
};

NotificationList.defaultProps = {
    onClick: noop,
};

export default NotificationList;
